import type { SVGProps } from "react";

export default function SolarLayersMinimalisticLinear(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}>
      <g fill="none" stroke="currentColor" strokeWidth={1.5}>
        <path d="M4.979 9.685C2.993 8.891 2 8.494 2 8s.993-.891 2.979-1.685l2.808-1.123C9.773 4.397 10.766 4 12 4s2.227.397 4.213 1.192l2.808 1.123C21.007 7.109 22 7.506 22 8s-.993.891-2.979 1.685l-2.808 1.123C14.227 11.603 13.234 12 12 12s-2.227-.397-4.213-1.192z" />
        <path strokeLinecap="round" d="M22 12s-.993.891-2.979 1.685l-2.808 1.123C14.227 15.603 13.234 16 12 16s-2.227-.397-4.213-1.192l-2.808-1.123C2.993 12.891 2 12 2 12" />
        <path strokeLinecap="round" d="M22 16s-.993.891-2.979 1.685l-2.808 1.123C14.227 19.603 13.234 20 12 20s-2.227-.397-4.213-1.192l-2.808-1.123C2.993 16.891 2 16 2 16" />
      </g>
    </svg>
  );
}
